import React from "react";
import { HeroPanel as HomeHeroPanel } from "../components/collections/HeroPanel";

export const HeroPanel = () => <HomeHeroPanel />;
